import $ from "jquery";
import {alterQueryString} from "./utils";

const defaults = () => ({
    threshold: 100,
    dir: "down",
    enabled: true
});

const directions = {
    down: {
        method: "append-content",
        shouldLoad(opts, $el) {
            const height = $el.height();
            const scrollHeight = $el.prop("scrollHeight");
            const scrollTop = $el.scrollTop();
            return scrollTop + height > scrollHeight - opts.threshold;
        },
        lastElement($els) {
            return $els.last();
        },
        preUpdate() {},
        postUpdate() {}
    },
    up: {
        method: "prepend-content",
        shouldLoad(opts, $el) {
            const scrollTop = $el.scrollTop();
            return scrollTop < opts.threshold;
        },
        lastElement($els) {
            return $els.first();
        },
        preUpdate($el, opts) {
            return {
                $el,
                scrollTop: $el.scrollTop(),
                scrollHeight: $el.prop("scrollHeight")
            }
        },
        postUpdate({$el, scrollTop, scrollHeight}) {
            $el.prop("scrollTop", scrollTop + $el.prop("scrollHeight") - scrollHeight);
        }
    }
};

function getItemFromElement($el, attrs) {
    const out = {};
    for (let i = 0; i < attrs.length; i++) {
        const attr = attrs[i];
        out[attr] = $el.attr("data-" + attr);
    }
    return out;
}

export function infiniteScroll(opts) {
    opts = Object.assign(defaults(), opts);
    const $el = $(opts.el);
    const dir = directions[opts.dir];
    const uidAttr = opts.attrs[0];
    let enabled = opts.enabled;
    let inProgress = false;
    let endReached = false;

    function getElements() {
        return $el.find(`[data-${uidAttr}]`);
    }

    function getLastItem($els) {
        const $item = dir.lastElement($els || getElements());
        return $item.length ? getItemFromElement($item, opts.attrs) : null;
    }

    function reachedEnd() {
        endReached = true;
        $el.off("scroll", handleScroll);
        if(opts.onEndReached) opts.onEndReached();
    }

    function load() {
        inProgress = true;

        const $els = getElements();
        const prevLength = $els.length;
        if(!prevLength) { // no items found, end is reached
            inProgress = false;
            reachedEnd();
            return;
        }
        const lastItem = getLastItem($els);

        let url = alterQueryString(opts.url, lastItem);
        url = AJAX.mergeParams(url, opts.attrs, opts.context);

        let dirCallbackRes;

        AJAX.send({
            url,
            scope: opts.scope,
            context: opts.context,
            method: dir.method,
            callbackPre() {
                dirCallbackRes = dir.preUpdate($el, opts);
            },
            callback() {
                inProgress = false;
                dir.postUpdate(dirCallbackRes);
                if(getElements().length === prevLength) {
                    reachedEnd();
                } else {
                    tryLoad(); // try loading until threshold is not met
                }
                if(opts.onUpdate) opts.onUpdate();
            }
        });
    }

    function tryLoad() {
        if(!enabled || inProgress || endReached) return;
        const shouldLoad = dir.shouldLoad(opts, $el);
        if(shouldLoad) load();
        return shouldLoad;
    }

    const handleScroll = VOID.utils.throttle(tryLoad, 100);

    if(enabled) {
        $el.on("scroll", handleScroll);
    }

    return {
        tryLoad,
        load,
        reEnable: function() {
            enabled = true;
            endReached = false;
        }
    };
}

export function boxInfiniteScroll(opts) {
    $(function () {
        const {scope, context, selector, cell, url} = opts;

        const $box = $(selector).closest(".box");

        const infScroller = infiniteScroll({
            enabled: true,
            el: selector,
            url,
            scope,
            context,
            attrs: ["s"], // the first attr is used to find the items
            onEndReached: function () {
                $(cell).find(".box-count").addClass("box-count-end");
            }
        });

        infScroller.tryLoad();

        AJAX.onUpdate(function (props) {
            if (props.scope === scope && props.context === context && props.method !== "append-content") {
                $(selector).scrollTop(0);
                infScroller.tryLoad();
            }
        });

        $box.on("boxzoom", function () {
            infScroller.tryLoad();
        });
    });
}
